import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import { ThemeProvider } from 'styled-components';
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import StyledIcon from '../../../../../../../../styledComponents/styles/Icon.styled';

import { themeViaForms } from '../../../../../../../../styledComponents/settings/theme';
import { AccentButtonMediumNunito } from '../../../../../../../../styledComponents/styles/Buttons.styled';
import { AccentButtonSpinner } from '../../../../../../../../styledComponents/styles/spinner.styled';
import { toast } from 'react-toastify';
import toastMessageStyles from '../../../../../../../viaGlobal/components/toastMessage/toastMessage.scss';
import ImageUploadIcon from '../../../../../../../travelerProfile/components/icons/ImageUploadIcon';
import UnsplashIcon from '../../../../../../../travelerProfile/components/icons/UnsplashIcon';
import UploadIcon from '../../../../../../../travelerProfile/components/icons/UploadIcon';
import ChevronLeftIcon from '../../../../../../../travelerProfile/components/icons/ChevronLeftIcon';
import CrownIcon from '../../../../../../../travelerProfile/components/icons/CrownIcon';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import UnsplashImageForm from '../../cards/UnsplashImageForm';
import UploadImageForm from '../../cards/UploadImageForm';
import ImageCardV2 from '../../cards/ImageCardV2';
import ImageDescModal from '../ImageDescModal';

import { 
        uploadProgramImages, 
        getProgramImages, 
        deleteProgramImages 
      } from '../../../../../../../../actions/programModifyActions';

import { uploadPlanImages, deletePlanImages, getPlan } from '../../../../../../../../actions/plans';

import style from "./style.scss";

export const enhance = compose(withStyles(style));

const ImageUploadModal = props => {
  const dispatch = useDispatch();
  const programImages = useSelector(state => state.programModify.programImages);
  const selectedPlan = useSelector(state => state.plans.plan);
  const freemium = useSelector(state => state.profile.freemium);

  const [showForm, setShowForm] = useState("");
  const [files, setFiles] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedUnsplashFile, setUploadedUnsplashFile] = useState([]);
  const [selectedImageIds, setSelectedImageIds] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disabledActions, setDisabledActions] = useState(false);
  const [unsplashIconColor, setUnsplashIconColor] = useState("#446372")
  const [uploadImageIconColor, setUploadImageIconColorr] = useState("#446372")
  const [showImageDescModal, setShowImageDescModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filesWithAltText, setFilesWithAltText] = useState([]);

  useEffect(()=>{
      if(showForm === "UploadImage" && !uploadedFile) {
        setIsDisabled(true);
      } else if(showForm === "UnsplashImage" && uploadedUnsplashFile.length===0) {
        setIsDisabled(true);
      } else if(isError) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }

  },[isError, showForm, uploadedFile, uploadedUnsplashFile])

  useEffect(()=>{
    if(props?.type === "program") {
      dispatch(getProgramImages(props?.program?.id))
    } else if(props?.type === "plan") {
      dispatch(getPlan(props?.planId))
    }
  },[])

  useEffect(()=>{
    let selectedImages = [];
    if(props?.type === "program" && programImages?.data?.length>0) {
      selectedImages = programImages?.data?.reduce((acc, programImage) => {
        if(!programImage.attributes.default_image) {
          acc.push({
            "id" : programImage.id,
            "client_account_id" : programImage.attributes.client_account_id,
            "file_name" : programImage.attributes.file_name,
            "s3_store" : programImage.attributes.background,
            "primary" : programImage.attributes.primary,
            "default_image" : programImage.attributes.default_image,
            "position": programImage.attributes.position,
            "alt_text": programImage.attributes.alt_text || ''
          })
        }
        return acc;
      }, []);
    } else if(props?.type === "plan" && selectedPlan?.plan?.attributes?.plan_images?.length>0) {
      const sortedPlanImages = selectedPlan?.plan.attributes.plan_images.sort((a, b) => a.position - b.position);
      selectedImages = sortedPlanImages.reduce((acc, planImage) => {
        if(!planImage.default_image) {
          acc.push({
            "id" : planImage.id,
            "client_account_id" : props.clientAccountId,
            "file_name" : planImage.file_name,
            "s3_store" : planImage.background,
            "primary" : planImage.primary,
            "default_image" : planImage.default_image,
            "position": planImage.position,
            "alt_text": planImage.alt_text || ''
          })
        }
        return acc;
      }, []);
    }

    setFiles(selectedImages);
    setFilesWithAltText(selectedImages);
  },[programImages, selectedPlan])

  const handleSelectedImage = (selectedId) => {
    if(selectedId) {
      setSelectedImageIds(prevIds => 
        prevIds.includes(selectedId) 
          ? prevIds.filter(id => id !== selectedId) 
          : [...prevIds, selectedId]
      );
    }
  }

  const handleSelectAllImage = () => {
    const ids = files.map((file)=>{
      return file.id
    })
    setSelectedImageIds(ids);
  }

  const handleUnSelectAllImage = () => {
    setSelectedImageIds([])
  }

  const handleDeleteImages = () => {
    const payload = {
      "image_ids" : selectedImageIds
    }
    setDisabledActions(true);
    
    if(props?.type === "program") {
      dispatch(
        deleteProgramImages(props?.programID, payload, (status, message) => {
          handleDeleteCallback(status, message);
        })
      );
    } else if(props?.type === "plan") {
      dispatch(
        deletePlanImages(props?.planId, payload, (status, message) => {
          handleDeleteCallback(status, message);
        })
      );
    }
  }

  const handleDeleteCallback = (status, message) => {
    if (status) {
      toast("Image(s) deleted", {
        type: 'success',
        className: toastMessageStyles['successContainer'],
        toastClassName: toastMessageStyles['wrapper'],
        bodyClassName: toastMessageStyles['successBody'],
        progressClassName: toastMessageStyles['progress-bar'],
        position: 'bottom-right'
      });
      const filteredImages = files.filter(image => !selectedImageIds.includes(image.id));
      setFiles(filteredImages);
      setFilesWithAltText(filteredImages);
      setDisabledActions(false);
      setSelectedImageIds([]);
    } else {
      toast(message, {
        type: 'error',
        className: toastMessageStyles['failureContainer'],
        toastClassName: toastMessageStyles['wrapper'],
        bodyClassName: toastMessageStyles['failureBody'],
        progressClassName: toastMessageStyles['progress-bar'],
        position: 'bottom-right'
      });
    }
  };

  const uploadFile = () => {
    const totalLength = files.length + 1;
    if(totalLength>10) {
      toast("You can only upload up to 10 files.", {
        type: 'error',
        className: toastMessageStyles['failureContainer'],
        toastClassName: toastMessageStyles['wrapper'],
        bodyClassName: toastMessageStyles['failureBody'],
        progressClassName: toastMessageStyles['progress-bar'],
        position: 'bottom-right'
      });
    }

    if (uploadedFile && files.length<10) {
      const reader = new FileReader();
      const sizeInMB = uploadedFile.size / (1024 * 1024);
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        if (sizeInMB.toFixed(2) > 10) {
          toast('File is too large, max is 10MB', {
            type: 'error',
            className: toastMessageStyles['failureContainer'],
            toastClassName: toastMessageStyles['wrapper'],
            bodyClassName: toastMessageStyles['failureBody'],
            progressClassName: toastMessageStyles['progress-bar'],
          });
        } else {
          const newFile  = {
            "id" : null,
            "client_account_id" : props?.type === "program" ? props?.program?.attributes?.primary_client_account_id : props?.clientAccountId,
            "file_name" : uploadedFile.name,
            "s3_store" : fileAsBinaryString,
            "primary" : true,
            "default_image" : false,
            "count": files.length + 1
          }
          setFiles(prevFiles => [...prevFiles, newFile]);
          setFilesWithAltText(prevFiles => [...prevFiles, newFile]);
        }
      };

      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.error('file reading has failed');
      reader.readAsDataURL(uploadedFile);
      setShowForm("");
      setUploadedFile(null);
    }
  };

  const uploadAllImages = async (images) => {
    setIsLoading(true);
    setDisabledActions(true);
    const uploadPromises = images.map((image) => {
      const payload = {
        "images" : [{
          ...image,
          alt_text: image.alt_text || ''
        }]
      }
      
      return new Promise((resolve) => {
        if(props?.type === "program") {
          dispatch(
            uploadProgramImages(props?.programID, payload, (status, message) => {
              resolve({ status, message });
            })
          );
        } else if(props?.type === "plan") {
          dispatch(
            uploadPlanImages(props?.planId, payload, (status, message) => {
              resolve({ status, message });
            })
          );
        } else {
          resolve({ status: false, message: "Invalid type" });
        }
      });
    });
  
    const results = await Promise.allSettled(uploadPromises);
    setIsLoading(false);
    setDisabledActions(false);
    // Check if all uploads were successful
    const failedUploads = results.filter(result => result.value && !result.value.status);
  
    if (failedUploads.length === 0) {
      toast("Image(s) updated.", {
        type: 'success',
        className: toastMessageStyles['successContainer'],
        toastClassName: toastMessageStyles['wrapper'],
        bodyClassName: toastMessageStyles['successBody'],
        progressClassName: toastMessageStyles['progress-bar'],
        position: 'bottom-right'
      });
      if(props?.type === "program") {
        props.setIsImageExists(true);
      } else if(props?.type === "plan") {
        dispatch(getPlan(props?.planId));
      }
      props.onClose();
    } else {
      toast("Some images failed to upload.", {
        type: 'error',
        className: toastMessageStyles['failureContainer'],
        toastClassName: toastMessageStyles['wrapper'],
        bodyClassName: toastMessageStyles['failureBody'],
        progressClassName: toastMessageStyles['progress-bar'],
        position: 'bottom-right'
      });
    }
  };

  const uploadProgramImage = () => {
    const updatedImages = filesWithAltText.map((item, index) => ({
      ...item,
      position: index + 1
    }));

    uploadAllImages(updatedImages);
  }

  const handleUnsplashFileUpload = (imageData) => {
      const newFile  = {
        "id" : null,
        "client_account_id" : props?.type === "program" ? props?.program?.attributes?.primary_client_account_id : props?.clientAccountId,
        "file_name" : imageData.name,
        "s3_store" : "",
        "unsplash_url" : imageData.url,
        "primary" : true,
        "default_image" : false,
        "unsplash_image": true,
        "unsplashID" : imageData.id,
        "count": files.length + uploadedUnsplashFile.length + 1
      }
      setUploadedUnsplashFile((prevFiles) => {
        return prevFiles.some((file) => file.unsplashID === imageData.id)
          ? prevFiles.filter((file) => file.unsplashID !== imageData.id) // Remove if already exists
          : [...prevFiles, newFile]; 
      });
  }

  const uploadUnsplashFile = () => {
    const totalFiles = uploadedUnsplashFile.length + files.length;
    if(totalFiles>10) {
      toast("You can only upload up to 10 files.", {
        type: 'error',
        className: toastMessageStyles['failureContainer'],
        toastClassName: toastMessageStyles['wrapper'],
        bodyClassName: toastMessageStyles['failureBody'],
        progressClassName: toastMessageStyles['progress-bar'],
        position: 'bottom-right'
      });
    }
    if(totalFiles<=10) {
      setFiles(prevFiles => [...prevFiles, ...uploadedUnsplashFile]);
      setFilesWithAltText(prevFiles => [...prevFiles, ...uploadedUnsplashFile]);
    }
    setShowForm("");
    setUploadedUnsplashFile([]);
  }

  const handleShowDescModal = (data) => {
    setSelectedFile(data);
    setShowImageDescModal(true);
  };

  const handleSaveAltText = (updatedFile) => {
    setFilesWithAltText(prevFiles => 
      prevFiles.map(file => 
        ((file.id!==null && file.id === updatedFile.id) || (file.id === null && file.count === updatedFile.count)) 
          ? { ...file, alt_text: updatedFile.alt_text } 
          : file
      )
    );
    
    setShowImageDescModal(false);
  };

  const getNoImageMessage = () => {
    if(props?.type === "program") {
      return "No images have been added to your program's carousel gallery yet.";
    } else {
      return "No images have been added to your plan's carousel gallery yet.";
    }
  };

  return (
    <ThemeProvider theme={themeViaForms}>
      <div className={style.flexContainer}>
        <Modal
          blockScroll={false}
          open={props.show}
          onClose={() => props.onClose(false)}
          center
          styles={{
            overlay: { background: 'rgba(0, 0, 0, 0.65)' },
            modal: {
                maxWidth: '52%',
                width: !!props.width ? props.width : '52%',
                borderRadius: '5px',
                padding: '0px',
            },
            closeButton: {
              marginTop: '5.8px',
              marginRight: '20.8px',
              width: '24px',
              height: '24px',
            },
          }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}
          closeIcon={<StyledIcon type="Close" color="#9FABAE" size="24px" />}
        >
          <div >
            <div className={style.header}>
              <span className={style.headerTitle}>Manage Cover Images</span>
              <a
                className={style.closeIcon}
                onClick={() => props.onClose(false)}
              >
                <StyledIcon type="Close" color="#373737" size="24px" />
              </a>
            </div>
            <div className={style.childContainer}>
              <div className={style.content}>
                { 
                  showForm === "UploadImage" ?
                    <>
                    <UploadImageForm 
                      setUploadedFile = {setUploadedFile}
                      uploadedFile={uploadedFile}
                      setIsError={setIsError}
                      isError={isError}
                    />
                    </>
                :
                  showForm === "UnsplashImage" ?
                  <>
                    <UnsplashImageForm 
                      handleUnsplashFileUpload = {handleUnsplashFileUpload}
                    />
                  </>  
                :
                <div className={style.contentWrapper}>
                  <div className={style.modalTitle}>Image Carousel</div>
                  <div className={style.modalSubTitle}>Add images from Unsplash or upload your own. Arrange them, and the first image will be your main cover image.</div>
                  <div className={style.buttonWrapper}>
                      <div className={style.leftButtonWrapper}>                           
                          <button type="button" disabled={disabledActions} onClick={handleSelectAllImage} className={style.link}>
                            Select All
                          </button>                          
                          <button type="button" disabled={disabledActions} onClick={handleUnSelectAllImage} className={style.link}>
                            Unselect All
                          </button>                          
                          <div className={style.deleteButton}>
                            <button type="button" disabled={disabledActions || selectedImageIds.length===0} onClick={handleDeleteImages} className={style.deleteImageButton}>
                              <StyledIcon color={"#A82425"} type={'Trash'} size={'13.777px'} /> 
                              <span>Delete</span>
                            </button>
                          </div>
                      </div>
                      <div  className={style.rightButtonWrapper}>
                          {freemium ?
                            <button type="button" className={style.unsplashButtonFreemium}>
                              <UnsplashIcon color={"#BC8C3F"} width={"14px"} height={"13px"}  />
                                Unsplash
                              <CrownIcon width={"14px"} height={"12px"}  />
                            </button>
                          :
                            <button 
                              type="button" 
                              disabled={disabledActions} 
                              onClick={()=>setShowForm("UnsplashImage")} 
                              className={`${style.unsplashButton}`}
                              onMouseEnter={() => setUnsplashIconColor("#FFFFFF")} 
                              onMouseLeave={() => setUnsplashIconColor("#446372")} 
                            >
                              <UnsplashIcon color={unsplashIconColor} />
                              Unsplash
                            </button>
                          }
                          <button type="button"  
                            disabled={(freemium && files.length>0) || disabledActions} 
                            onClick={()=>setShowForm("UploadImage")} 
                            className={style.uploadImageButton}
                            onMouseEnter={() => setUploadImageIconColorr("#FFFFFF")} 
                            onMouseLeave={() => setUploadImageIconColorr("#446372")} 
                          >
                            <UploadIcon color={uploadImageIconColor} />
                            Upload Image
                          </button>
                      </div>
                  </div>
                  {filesWithAltText.length===0 ?
                    <div className={style.noDataWrapper}>
                      <div className={style.noImageIcon}>
                        <ImageUploadIcon />
                      </div>
                      <div className={style.noImageTitle}>{getNoImageMessage()}</div>
                      <div className={style.noImageSubTitle}>A default image will be displayed on the brochure until you upload your own.</div>
                    </div>
                    :
                    <div className={style.imageList}>
                    {
                      filesWithAltText.length>0 && filesWithAltText?.map((file,index)=>(
                        <>
                          <ImageCardV2 
                            file={file}
                            key={index+1}
                            index={index}
                            handleShowDescModal= {()=>handleShowDescModal(file)}
                            selectedImageIds={selectedImageIds}
                            handleSelectedImage={handleSelectedImage}
                            moveCard={(dragIndex, hoverIndex) => {
                              // swap(dragIndex, hoverIndex);
                              // move(dragIndex, hoverIndex); 
      
                              const sourceIndex = dragIndex;
                              const destinationIndex = hoverIndex;
                          
                              // If source and destination are the same, no need to reorder
                              if (sourceIndex === destinationIndex) return;
                          
                              // Create a copy of the fields array
                              const updatedFiles = [...files];
                          
                              // Get the dragged item
                              const [movedFile] = updatedFiles.splice(dragIndex, 1);
                              
                              // Insert the dragged item at the new position
                              updatedFiles.splice(hoverIndex, 0, movedFile);
                          
                              // Update the fields array using replace
                              setFiles(updatedFiles);
                              setFilesWithAltText(updatedFiles);
                            }}
                            totalFiles={files.length}
                          />
                        </>
                      ))
                    }
                    </div>
                  }
                  {freemium && files.length > 0 &&
                    <div className={style.freemiumBannerContainer}>
                      <div className={style.freemiumBanner}>
                        <div><CrownIcon /></div>
                        <div>
                          <div className={style.freemiumTitle}>Upgrade to Premium</div>
                          <div className={style.freemiumDesc}>Adding more than 1 carousel image is a premium feature. Please <a href="https://www.viatrm.com/schedule-a-demo/" target='_blank'>upgrade</a> your subscription plan.</div>
                        </div>
                      </div>
                    </div>
                  }
                </div>                              
                }
              </div>
            </div>
            <div className={style.footer}>
              {showForm === "UnsplashImage" || showForm === "UploadImage" ?
                <div className={style.buttonContainer}>
                  <button 
                    type="button" 
                    onClick={()=>{
                        setUnsplashIconColor("#446372");
                        setUploadImageIconColorr("#446372");
                        setShowForm("");
                      }
                    } 
                    className={style.galleryButton}>
                      <ChevronLeftIcon /> <span>Back to Gallery</span>
                  </button>
                  <AccentButtonMediumNunito
                    type={'button'}
                    onClick={showForm === "UnsplashImage" ? uploadUnsplashFile : uploadFile}
                    disabled={isDisabled}
                  >
                    Add
                  </AccentButtonMediumNunito>
                </div>
                :
                <AccentButtonMediumNunito
                  type="button"
                  onClick={uploadProgramImage}
                  disabled={isLoading || disabledActions}
                >
                  {isLoading ? <AccentButtonSpinner displayText="Saving ..." /> : 'Save'} 
                </AccentButtonMediumNunito>
              }              
            </div>
          </div>
          {showImageDescModal && (
              <ImageDescModal 
                show={showImageDescModal}
                onClose={setShowImageDescModal}
                selectedFile={selectedFile}
                onSave={handleSaveAltText}
              />
          )}
        </Modal>
      </div>
    </ThemeProvider>
  );
};

export default DragDropContext(HTML5Backend)(enhance(ImageUploadModal));